export function formatNPR(amount: number, short = false): string {
  const symbol = short ? 'Rs.' : 'रु.';
  return `${symbol} ${amount.toLocaleString('en-IN')}`;
}

export function formatNPRCompact(amount: number): string {
  if (amount >= 10_000_000) return `रु. ${(amount / 10_000_000).toFixed(1)}Cr`;
  if (amount >= 100_000) return `रु. ${(amount / 100_000).toFixed(1)}L`;
  return formatNPR(amount);
}

export function formatDate(date: string | Date): string {
  return new Date(date).toLocaleDateString('en-NP', {
    year: 'numeric', month: 'short', day: 'numeric',
  });
}

export function getInitials(name: string, max = 2): string {
  return name.split(' ').filter(Boolean).slice(0, max).map((w) => w[0]).join('').toUpperCase();
}
